<template>
  <span>{{ amountTotal }}</span>
</template>

<script>
import {mapGetters} from 'vuex';

import * as constants from '../../../common/constants';

export default {
  props: {
    forceFloat: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      'paymentMethod',
      'choiceList',
      'choices'
    ]),
    amountTotal() {
      let amount = 0;

      this.choiceList.forEach(stackLetter => {
        const choice = this.choices.find(c => {
          if (c.paymentMethod === this.paymentMethod &&
              c.recurrence === constants.RECURRENCE_X2 &&
              c.stackLetter === stackLetter) {
            return true;
          }

          return false;
        });

        if (typeof choice !== 'undefined') {
          amount += Number(choice.price);
        }
      });

      amount *= 2;

      if (this.forceFloat) {
        return Number.parseFloat(amount).toFixed(2);
      }

      return Number.isInteger(amount) ? Number.parseInt(amount, 10) : amount;
    }
  }
};
</script>



// WEBPACK FOOTER //
// amount-total-x2-total.vue?b98864c6